var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9297 32.6032L31.737 31.5389C31.6606 31.5133 31.5806 31.5001 31.5 31.4999H25.5C25.4194 31.5001 25.3394 31.5133 25.263 31.5389L22.0703 32.6032C19.6381 33.4112 17.9977 35.6871 18 38.2499C18 38.6641 18.3358 38.9999 18.75 38.9999H38.25C38.6642 38.9999 39 38.6641 39 38.2499C39.0023 35.6871 37.3619 33.4112 34.9297 32.6032Z",
    fill: "#1312DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18C26.0147 18 24 20.0147 24 22.5V25.5C24.0024 27.9843 26.0157 29.9975 28.5 30C30.9842 29.9975 32.9975 27.9843 33 25.5V22.5C33 20.0147 30.9853 18 28.5 18Z",
    fill: "#1312DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.6f607575fccf6caf7a1b0f0ab9793f47.svg";
export { ForwardRef as ReactComponent };